import React, { useContext, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import classNames from 'classnames'
import { useErrorService } from '@abroad/components'
import { OrgEcoIdsContext } from '../../utils/contexts'
import API from '../../utils/API'

const ToggleCircleSchedulingCheckbox = () => {
  const { companyAndEcoInfo, setCompanyAndEcoInfo } =
    useContext(OrgEcoIdsContext)
  const [isSchedulingEnabled, setIsSchedulingEnabled] = useState(
    companyAndEcoInfo?.isCircleSchedulingEnabled || false,
  )
  const [isLoading, setIsLoading] = useState(false)
  const Error = useErrorService()

  useEffect(() => {
    if (companyAndEcoInfo?.isCircleSchedulingEnabled) {
      setIsSchedulingEnabled(true)
    } else {
      setIsSchedulingEnabled(false)
    }
  }, [companyAndEcoInfo])

  const toggleWisdomAssessmentEnabled = async () => {
    setIsLoading(true)
    try {
      const { status } =
        await API.AdminAPI.entityService.toggleEntityWisdomAssessmentEnabled(
          'company',
          companyAndEcoInfo?._id,
          {
            isWisdomEnabled: companyAndEcoInfo?.isWisdomEnabled,
            isCircleSchedulingEnabled: !isSchedulingEnabled,
          },
        )
      if (status) {
        setIsSchedulingEnabled(!isSchedulingEnabled)
        setCompanyAndEcoInfo((prev) => ({
          ...prev,
          isCircleSchedulingEnabled: !isSchedulingEnabled,
        }))
        setIsLoading(false)
      }
    } catch (e) {
      Error.showError(e)
      setIsLoading(false)
    }
  }

  return (
    <div className='wisdom-enabled-checkbox mb-point-75'>
      <Form.Check
        id='isSchedulingEnabled'
        custom={true}
        onChange={toggleWisdomAssessmentEnabled}
        checked={isSchedulingEnabled ? true : false}
        type='checkbox'
        label='Is Circle Scheduling Enabled'
        className={classNames('s6', {
          'cursor-pointer': !isLoading,
          'pointer-events-none': isLoading,
        })}
        disabled={isLoading}
      />
      {isLoading && <span className='s7'>Updating...</span>}
    </div>
  )
}

export default ToggleCircleSchedulingCheckbox
